
export const ContactPage: React.FC = () => {
    return (
        <div id="contact-page">
            <h1>Contact</h1>
            <p>Phone: 123-456-7890</p>
            <p>Email: </p>
        </div>
    );
}